import React from 'react';
import { Helmet } from 'react-helmet-async';
import { TokenSessionProvider } from './TokenSessionProvider';

export default function LayoutEmbed({ children }) {
  return (
    <TokenSessionProvider>
      <Helmet>
        <script src="/js/iframeResizer.contentWindow.min.js" />
        <script>{`
          window.iFrameResizer = {
            heightCalculationMethod: 'taggedElement'
          };
        `}</script>
        <style>{`
          body { background:transparent !important }    
          `}
        </style>
      </Helmet>
      {children}
      <div 
        data-iframe-height
        style={{ height: '1px', width: '100%', backgroundColor: 'transparent' }} 
      />
    </TokenSessionProvider>
  );
}
 